// 로그아웃 시 반드시 함께 일어나야 하는 것들.
//
// 진입점이 두 개(AppMyAccountContextMenu, AppSignOutButton)인데 서로 다른 일을 하고 있었다 —
// 컨텍스트 메뉴는 ChannelTalk 종료와 GA 차단까지 했고, 버튼은 토큰만 지웠다.
// 그래서 어느 버튼으로 로그아웃했는지에 따라 상담 위젯이 남아 있기도 했다.

import { clearTokens } from "@/utils/jwt";
import { shutdownChannelTalk } from "@/shared/utils/channelTalk";
import { resetAnalyticsIdentity } from "@/shared/analytics/analytics";

export function runSignOutSideEffects(): void {
  clearTokens();
  shutdownChannelTalk();

  // GA4 수집을 끄지 않는다. 로그아웃 후의 익명 브라우징도 정상 트래픽이고,
  // 내부 직원이라면 traffic_type 라벨이 유지돼 GA4 데이터 필터가 계속 걸러낸다.
  resetAnalyticsIdentity();

  // private-layout 이 로그인 페이지로 튕기는 동작을 억제하는 데 쓰는 플래그다 (분석과 무관).
  sessionStorage.setItem("signOut", "true");
}
